module.exports = __webpack_public_path__ + "img/Dani Ceballos.2d56fc69.png";